(function () {
  if (window.__waltersCartInit) return;
  window.__waltersCartInit = true;

  var SHIPPING_GOAL_CENTS = 4000;

  function moneyFormat(cents) {
    var d = (cents / 100);
    if (d === Math.floor(d)) return '$' + d.toFixed(0) + '.00';
    return '$' + d.toFixed(2);
  }

  // Free-shipping threshold in the active market currency. cart.total_price is
  // converted (presentment) in CAD/AUD/etc., so the goal must convert too —
  // mirror Shopify: convert the base USD goal then round UP to a whole unit.
  function shippingGoalCents() {
    var base = SHIPPING_GOAL_CENTS;
    try {
      var c = window.Shopify && Shopify.currency;
      if (c && c.active && c.active !== 'USD') {
        var rate = parseFloat(c.rate || '1');
        if (rate && rate !== 1) return Math.ceil((base * rate) / 100) * 100;
      }
    } catch (e) {}
    return base;
  }

  // Inline-update progress bar from /cart.js — instant, no section fetch.
  function updateProgressInline() {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var prog = document.querySelector('cart-drawer .walters-cart-progress');
        if (!prog) return cart;
        if (cart.item_count === 0) {
          prog.style.display = 'none';
          return cart;
        }
        prog.style.display = '';
        var msg = prog.querySelector('.walters-cart-progress__msg');
        var fill = prog.querySelector('.walters-cart-progress__fill');
        var cents = cart.total_price;
        var GOAL = shippingGoalCents();
        var pct = Math.min(100, (cents * 100) / GOAL);
        if (fill) fill.style.width = pct + '%';
        if (cents >= GOAL) {
          prog.classList.add('is-reached');
          if (msg) msg.innerHTML = 'Free shipping unlocked!';
        } else {
          prog.classList.remove('is-reached');
          var remaining = GOAL - cents;
          if (msg) msg.innerHTML = "You're <strong>" + moneyFormat(remaining) + "</strong> away from free shipping!";
        }
        return cart;
      })
      .catch(function (err) { console.error('Walter’s progress update failed', err); });
  }

  // Refresh upsell only (whole sections fetch). Cart-drawer-items handles items+totals.
  function refreshUpsell() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var newUpsell = tmp.querySelector('.walters-cart-upsell');
          var oldUpsell = document.querySelector('cart-drawer .walters-cart-upsell');
          if (newUpsell) {
            if (oldUpsell) oldUpsell.replaceWith(newUpsell);
            else {
              var body = document.querySelector('cart-drawer .cart-drawer__body');
              if (body) body.appendChild(newUpsell);
            }
          } else if (oldUpsell) {
            oldUpsell.remove();
          }
          // Empty-cart toggle
          var nowEmpty = tmp.querySelector('cart-drawer.is-empty, cart-drawer .is-empty') !== null
                         || (tmp.querySelector('cart-drawer') && tmp.querySelector('cart-drawer').classList.contains('is-empty'));
          var current = document.querySelector('cart-drawer');
          if (current) current.classList.toggle('is-empty', nowEmpty);
        }
        if (data['cart-icon-bubble']) {
          var iconHost = document.getElementById('cart-icon-bubble');
          if (iconHost) {
            var iconTmp = document.createElement('div');
            iconTmp.innerHTML = data['cart-icon-bubble'];
            var fresh = iconTmp.querySelector('#cart-icon-bubble');
            if (fresh) iconHost.innerHTML = fresh.innerHTML;
          }
        }
      })
      .catch(function (err) { console.error('Walter’s upsell refresh failed', err); });
  }

  function refreshAll() {
    updateProgressInline();
    refreshUpsell();
  }

  // Click handler for upsell ADD button (event delegation, survives DOM re-render)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-walters-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var label = btn.querySelector('.walters-cart-upsell__btn-label');
    btn.disabled = true;
    if (label) label.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed: ' + r.status);
        return r.json();
      })
      .then(function () {
        // Reload cart-drawer fully (new line item) — let theme reset items, then refresh ours.
        return fetch('/?sections=cart-drawer,cart-icon-bubble', { cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data['cart-drawer']) {
              var tmp = document.createElement('div');
              tmp.innerHTML = data['cart-drawer'];
              var freshDrawer = tmp.querySelector('cart-drawer');
              var currentDrawer = document.querySelector('cart-drawer');
              if (freshDrawer && currentDrawer) {
                var wasActive = currentDrawer.classList.contains('active');
                currentDrawer.innerHTML = freshDrawer.innerHTML;
                currentDrawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
                if (wasActive) currentDrawer.classList.add('active');
              }
            }
            if (data['cart-icon-bubble']) {
              var iconHost = document.getElementById('cart-icon-bubble');
              if (iconHost) {
                var iconTmp = document.createElement('div');
                iconTmp.innerHTML = data['cart-icon-bubble'];
                var fresh = iconTmp.querySelector('#cart-icon-bubble');
                if (fresh) iconHost.innerHTML = fresh.innerHTML;
              }
            }
          });
      })
      .catch(function (err) {
        console.error('Walter’s upsell add failed', err);
        btn.disabled = false;
        if (label) label.textContent = 'Add';
      });
  });

  // Patch fetch — inline progress + upsell refresh on any cart mutation
  var origFetch = window.fetch;
  window.fetch = function () {
    var first = arguments[0];
    var url = (typeof first === 'string') ? first : (first && first.url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)/.test(url);
    var isSectionFetch = url.indexOf('sections=') !== -1;
    var promise = origFetch.apply(this, arguments);
    if (isCartMutation && !isSectionFetch) {
      promise.then(function () {
        // Run inline progress update fast, upsell refresh after cart-drawer-items has settled
        setTimeout(updateProgressInline, 50);
        setTimeout(refreshUpsell, 250);
      });
    } else if (isSectionFetch && url.indexOf('cart-drawer') !== -1) {
      // A re-render of the cart-drawer section ships the server-rendered (USD) progress
      // value; re-run the currency-aware calc once it's swapped into the DOM.
      promise.then(function () { setTimeout(updateProgressInline, 60); });
    }
    return promise;
  };

  // XHR fallback (some themes use XHR)
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__waltersCartUrl = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var url = this.__waltersCartUrl || '';
    if (/\/cart\/(add|change|update|clear)/.test(url) && url.indexOf('sections=') === -1) {
      this.addEventListener('load', function () {
        setTimeout(updateProgressInline, 50);
        setTimeout(refreshUpsell, 250);
      });
    }
    return origSend.apply(this, arguments);
  };

  // MutationObserver fallback — watch the cart-icon bubble count.
  // Whenever theme updates the bubble count, our progress should re-sync too.
  function startBubbleWatcher() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) {
      setTimeout(startBubbleWatcher, 500);
      return;
    }
    var obs = new MutationObserver(function () {
      updateProgressInline();
    });
    obs.observe(bubble, { childList: true, subtree: true, characterData: true });
  }
  function init() { startBubbleWatcher(); updateProgressInline(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
